import React from 'react';
import PortfolioCardDesktop from './PortfolioCardDesktop';
import styles from '../styles/stylesPortfolioDesktop';
import projects from '../data/dataPortfolio';
import usePortfolioLogic from '../hooks/usePortfolioLogic';

function PortfolioDesktop() {
  const { carouselRef, activeIndex } = usePortfolioLogic();

  return (
    <section id="portfolio" style={styles.container}>
      <h2 style={styles.title}>Portfólio</h2>
      <div style={styles.carouselWrapper}>
        <div ref={carouselRef} style={styles.carousel}>
          {projects.map((project, index) => (
            <div
              key={project.id}
              style={{
                ...styles.cardWrapper,
                ...(index === activeIndex
                  ? styles.cardActive
                  : styles.cardInactive)
              }}
            >
              <PortfolioCardDesktop {...project} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PortfolioDesktop;
